import * as yup from "yup";

const EMAIL_DOMAIN_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

interface IEmailValidationMessages {
  invalidDomain: string;
  invalidEmail: string;
  required: string;
}

const DEFAULT_MESSAGES: IEmailValidationMessages = {
  invalidDomain: "Email must include a valid domain (e.g. example@gmail.com).",
  invalidEmail: "Please double-check if the email is correct.",
  required: "Email is required.",
};

export const createEmailValidationSchema = (
  messages: IEmailValidationMessages = DEFAULT_MESSAGES
) =>
  yup
    .string()
    .trim()
    .matches(EMAIL_DOMAIN_REGEX, messages.invalidDomain)
    .email(messages.invalidEmail)
    .required(messages.required);
